import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private httpClient = inject(HttpClient);
  private storageService = inject(StorageService);
  private readonly BASE_URL = environment.BASE_URL;
  
  refreshToken() {
    return this.httpClient.post(`${this.BASE_URL}/auth/refreshtoken`, {
      userId: this.storageService.getUserId(),
      refreshToken: this.storageService.getRefreshToken(),
      uuid: this.storageService.getCookie()
    });
  }
}
